import { Component, OnInit } from '@angular/core';
import { BaseSubcomp } from '../../../base-subcomp';

@Component({
  selector: 'app-portalrobot-subcomp-parent',
  templateUrl: './portalrobot-subcomp-parent.component.html',
  styleUrl: './portalrobot-subcomp-parent.component.scss',
    standalone: false
})
export class PortalrobotSubcompParentComponent extends BaseSubcomp implements OnInit
{
    CmError = false;

    ngOnInit(): void
    {


    }

}
